module.exports = __webpack_public_path__ + "img/python.76827a34.svg";